<template>

<vx-card no-shadow>
<!-- test -->
  <!-- Img Row -->
  <div class="vx-row">
  <div class="flex flex-wrap items-center">
    <!-- <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4"/> -->
    <div id="btnall"  @click="updateProfile=true">
      <div class="btn hover1">
        <img :src="imageVal" style="width:80px; height:80px;" class="mr-4 mb-4"/>
        <!-- <feather-icon class="btn2none" icon="EditIcon" @click="updateProfile=true"/> -->
        <div class="btn2over">
          <feather-icon style="width:20px; height:20px;" icon="EditIcon"/>
        </div>
        <!-- <vs-button @click="updateProfile=true" color="primary" type="border">아바타 변경</vs-button> -->
      </div>
    </div>

        <vs-popup classContent="popup-example items-center" title="아바타 변경" :active.sync="updateProfile">
          <h6 class="mb-2"> 아바타를 변경해보세요. </h6>
            <ul class="centerx flex items-center vx-row mb-4" style="margin-left:10px;">
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="user01.png">
                  <img src="@/assets/images/portrait/small/user01.png" style="width:85px; height:85px;"/>
                </vs-radio>
              </li>
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="professor_avatar.png">
                  <img src="@/assets/images/portrait/small/professor_avatar.png" style="width:85px; height:85px;" />
                </vs-radio>
              </li>
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="user02.png">
                  <img src="@/assets/images/portrait/small/user02.png" style="width:85px; height:85px;" />
                </vs-radio>
              </li>
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="user03.png">
                  <img src="@/assets/images/portrait/small/user03.png" style="width:85px; height:85px;" />
                </vs-radio>
              </li>
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="user04.png">
                  <img src="@/assets/images/portrait/small/user04.png" style="width:85px; height:85px;" />
                </vs-radio>
              </li>
              <li style="margin:15px;">
                <vs-radio v-model="radioVal" vs-value="user05.png">
                  <img src="@/assets/images/portrait/small/user05.png" style="width:85px; height:85px;" />
                </vs-radio>
              </li>
            </ul>

              <div class="vx-row justify-end" style="margin:15px;">
                <vs-button @click="updateImage()"> 완료 </vs-button>
              </div>
        </vs-popup>
    <!-- <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4"/>
    <vs-button class="mr-4 sm:mb-0 mb-2" icon-pack="feather" icon="icon-image" type="flat" color="dark" size="70px;" ></vs-button>
    <vs-button type="flat" color="danger" icon-pack="feather" icon="icon-trash"/>
    <div class="mr-4 sm:mb-0 mb-2">
      <vs-upload multiple text="Attachments" :show-upload-button="false" class="compose-mail-attachment" />
    </div>
        <p class="text-sm mt-2">800kB이하의 JPG, GIF, PNG 파일만 가능합니다.</p> -->
   </div>
  </div>
  <!-- Info -->
  <vs-input class="w-full mb-base" label="이름" placeholder="이름" v-model="username"></vs-input>
  <!-- <vs-input class="w-full mb-base" label-placeholder="Name" v-model="name"></vs-input> -->
  <vs-input disabled class="w-full my-4" label="이메일" placeholder="예) user01@filledyou.com" v-model="email"></vs-input>
  <!-- <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
    <span>Your account is not verified. <a href="#" class="hover:underline">Resend Confirmation</a></span>
  </vs-alert> -->
  <!-- <vs-input class="w-full my-base" label-placeholder="Company" v-model="company"></vs-input> -->
  <!-- Save & Reset Button -->
  <div class="flex flex-wrap items-center justify-end">
    <!-- <vs-button class="ml-auto mt-2">Save Changes</vs-button>
    <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
    <vs-button class="ml-auto mt-2" @click="save()">저장</vs-button>
    <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">초기화</vs-button> -->
  </div>
</vx-card>
</template>

<script>
import Main from "./Main.vue"
import Password from "./Password.vue"
import Withdrawal from "./Withdrawal.vue"

export default {
  components: {
    Main,
    Password,
    Withdrawal
  },

data() {
  return {
    updateProfile:false,
    radioVal:this.$store.state.AppActiveUser.photoName,
    popupActive: false,
    // username: "johny_01",
    username: this.$store.state.AppActiveUser.displayName,
    email: this.$store.state.AppActiveUser.email,
    imageVal: this.$store.state.AppActiveUser.photoURL
    // company: "SnowMash Technologies Pvt Ltd",
  }
},
computed: {
  activeUserInfo() {
    return this.$store.state.AppActiveUser
  },
},
create(){
},
methods:{
  successUpload(){
    this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
  },
  updateImage() {
    this.imageVal = require('@/assets/images/portrait/small/'+ this.radioVal)
    this.updateProfile = false
  },
  save () {
    this.$store.commit('UPDATE_USER_IMAGE', this.imageVal)
    this.$store.dispatch('auth/updateUsername', {'name':this.username, 'photo_url': this.radioVal})
    .then(()=>{
      // this.updateProfile = false
      this.$vs.notify({
        color: 'success',
        title: '완료',
        text: '아바타를 변경하였습니다.'
      })
    }).catch(() => {
      // this.updateProfile = false
      this.$vs.notify({
        color: 'danger',
        title: '실패',
        text: '관리자에게 문의 부탁 드립니다.'
      })
    })
  }
}
}
</script>

<style>
.btnall{
width:80px;
height:80px;
position: relative;
cursor: pointer;
overflow: hidden;
box-shadow: 2px 2px 8px 0px #000;
}

.btn {
 display:show;
 width:78px;
 height:78px;
 line-height:40px;
 margin:12px auto;
 z-index:1;
 overflow: hidden;
 text-align:center;
 cursor: pointer;
 -moz-border-radius: 50px;
 -webkit-border-radius: 50px;
 border-radius: 50px;

 transition:all 0.9s, color 0.3;
 }
 .btn:hover{color:#fff;}

 .hover1:hover {
  box-shadow:100px 0 0 0 rgba(0,0,0,0.2) inset;
  opacity: 0.8;
  }

     .btn2over {
        /* display:inline;
        line-height:40px;
        margin:15px auto;
        left: 50%;
        margin-top: 20px;
        margin-left: -70px;
        text-align:center;
        cursor: pointer;
        transition:all 0.9s, color 0.3; */
        display:show;
        padding:5px;
        color:#505050;
        line-height:40px;
        margin:15px auto;
        left: 50%;
        margin-top: -55px;
        margin-left: 20px;
        text-align:center;
        cursor: pointer;
        }
        .btn2over:hover{color:#000000;}

        .btn2none {
           /* display:inline;
           line-height:40px;
           margin:15px auto;
           left: 50%;
           margin-top: 20px;
           margin-left: -70px;
           text-align:center;
           cursor: pointer;
           transition:all 0.9s, color 0.3; */
           display:none;
           padding:5px;
           color:#000000;
           line-height:40px;
           margin:15px auto;
           left: 50%;
           margin-top: -70px;
           margin-left: -5px;
           text-align:center;
           cursor: pointer;
           }
           .btn2none:hover{color:#000000;}

     #btn > #btn2over {
     opacity: 0;
     transition: opacity 1s
     }


</style>
